import React from 'react';
import { useTranslation } from 'react-i18next';
import { useMutation, useQuery } from '@apollo/client';
import { Stack, Typography } from '@mui/material';
import { OPERATION_SEND_SMS } from 'pages/Coupons/operations-gql/mutations';
import ActionModal from 'components/Modal/ActionModal';
import { useLocation, useParams } from 'react-router-dom';
import {
  OPERATION_FIND_COUPON_H3,
  OPERATION_FIND_COUPON_STANDARD,
} from 'pages/Coupons/operations-gql/queries';
import { useNavigate } from 'router';
import { toast } from 'components/global/CUK/Toast/Toast';
import { trackEvent } from 'analytics';

const SendCode = ({ phone }) => {
  const { t } = useTranslation();
  const location = useLocation();
  const { id } = useParams();
  const [sendCode, { loading, error }] = useMutation(OPERATION_SEND_SMS, {
    variables: {
      id: +id!,
    },
    onCompleted: () => {
      trackEvent('send_sms', {
        code_type: location.pathname.includes('standard') ? 'standard' : 'h3',
      });
      toast.success(t('coupons.actions.send_code.toast_success'));
      handleClose();
    },
    onError: () => {
      toast.error(t('coupons.actions.send_code.toast_error'));
    },
  });

  const findQuery = location.pathname.includes('standard')
    ? OPERATION_FIND_COUPON_STANDARD
    : OPERATION_FIND_COUPON_H3;

  const { data } = useQuery(findQuery, {
    variables: {
      id: +id!,
    },
  });

  const navigate = useNavigate();
  const handleClose = () => {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    navigate({ pathname: '..' });
  };

  return (
    <ActionModal
      cancelLabel={t('ran.actions.cancel')}
      confirmColor="primary"
      confirmLabel={t('coupons.actions.send_code.send')}
      description={(
        <Stack gap={2}>
          <Typography>
            {t('coupons.actions.send_code.desc', { phone: data?.coupon?.phone })}
          </Typography>
          <Typography>{phone}</Typography>
        </Stack>
      )}
      icon={<i className="fa-light fa-message-sms" />}
      loading={loading}
      onClose={handleClose}
      onConfirm={() => sendCode()}
      title={t('coupons.actions.send_code.menu')}
      variant="primary"
    >
      {error && (
        <Typography color="error">
          {t('coupons.actions.send_code.modal_error_header')}
          {error.graphQLErrors.map(e => <Typography key={e.message}>{e.message}</Typography>)}
        </Typography>
      )}
    </ActionModal>
  );
};

export default SendCode;
